import { G, Path, Circle } from '@react-pdf/renderer';
import { Fragment } from 'react';


const microphonePaths = {
  'ceilingmic': (
    <Fragment>
      <Path d="M35.7 30.5a5.6 5.7 0 0 0 0 -11.4h-21.4a5.6 5.7 0 0 0 0 11.4z" />
      <Path d="M32.5 29.8v-6 m-3 0v6 m-3 0v-6 m-3 0v6 m-3 0v-6 m-3 0v6" strokeWidth="1.5" />
    </Fragment>
  ),
  'pendantmic': (
    <Fragment>
      <Path d="M35.7 32.4a5.6 5.7 0 0 0 0 -11.4h-21.4a5.6 5.7 0 0 0 0 11.4z" />
      <Path d="M32.4 31.6v-5.6 m-3 0 v5.6 m-3 0 v-5.6 m-3 0 v5.6 m-3 0v-5.6 m-3 0 v5.6 M24.8 20.2V8.2" strokeWidth="1.5" />
    </Fragment>
  ),
  'tabletopmic': (
    <Fragment>
      <Path d="M20 40.2h10 m-5 -1v-4m8.4 -8.2c-2 9.6 -14.8 9.6 -16.8 0m3 -11.6a5.4 5.4 0 0 1 10.8 0v10a5.4 5.4 0 1 1 -10.8 0v-10z" />
      <Path d="M29.4 15h-5.4m0 2h5.4m0 2h-5.4m0 2h5.4m0 2h-5.4m0 2h5.4" strokeWidth="1.5" />
    </Fragment>
  ),
  'videobar': (
    <Fragment>
      <Path d="m9 19 h32 a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-32a2 2 0 0 1 -2 -2v-8a2 2 0 0 1 2 -2z" />
      <Path d="m22.5 22.5 h5a1 1 0 0 1 1 1v3a1 1 0 0 1 -1 1h-5a1 1 0 0 1 -1 -1v-3a1 1 0 0 1 1 -1z" />
      <Circle cx="14" cy="25" r="3.5" />
      <Circle cx="36" cy="25" r="3.5" />
    </Fragment>
  ),
  'audiobar': (
    <Fragment>
      <Path d="m9 19 h32 a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-32a2 2 0 0 1 -2 -2v-8a2 2 0 0 1 2 -2z" />
      <Circle cx="14" cy="25" r="3.5" />
      <Circle cx="36" cy="25" r="3.5" />
    </Fragment>
  ),
};

const speakerPaths = {
  'ceilingspkr': (
    <Path d="M26.7 12v25.9l-9.2-7.4h-7.7v-11.2h7.7zm7 2.6a25.3 25.3 0 0 1 0 20.8m-3.4-2.7a22 22 0 0 0 0-15.4m6.7-5.4a29.4 29.4 0 0 1 0 26.2"/>
  ),
  'barspkr': microphonePaths['videobar'],
};

const cameraPaths = {
  'standAlone': (
    <Fragment>
            <Path d="m14 16h10a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3h-10a3 3 0 0 1-3-3v-10a3 3 0 0 1 3-3z" />
            <Path d="m30.5 21.5l8-5v16l-8-5v-6z" />
    </Fragment>
  ),
  'barCamera': microphonePaths['videobar'],
};

const Icons = {
  LoadingDock: () =>
    <Path d="m6.096 0h-3.048v-3.048h3.048zv-24.384h24.384v24.384zl24.384-24.384m-24.384 0l24.384 24.384h3.048v-3.048h-3.048" stroke={"#000"} />,

  Speaker: ({model = 'ceilingspkr'}) =>
    <G fill='none' strokeWidth='1' strokeMiterlimit='0' transform="translate(-24 -24)">
      <Circle cx="25" cy="25" r="23" fill={'#e6e7e8'} stroke={'#d7282f'} />
      <G fill="none" stroke={'#2d2f38'}>
          {speakerPaths[model] ?? null}
        </G>
    </G>,

  DeviceArrow: ({ angle }) =>
    <Path d='m60 0l-30-12q8 12 0 24z' stroke={'#d7282f'} fill={'#d7282f'} strokeWidth='1' transform={`rotate(${angle})`} />,

  Microphone: ({model}) => {
    return (
      <G fill='none' strokeWidth='1' strokeMiterlimit='0' transform="translate(-24 -24)">
        <Circle cx="25" cy="25" r="23" fill={'#e6e7e8'} stroke={'#d7282f'} />
        <G fill="none" stroke={'#2d2f38'}>
          {microphonePaths[model] ?? null}
        </G>
      </G>
    )
  },

  Camera: ({model = 'standAlone'}) => {
    return (
      <G fill='none' strokeWidth='1' strokeMiterlimit='0' transform="translate(-24 -24)">
        <Circle cx="25" cy="25" r="23" fill={'#e6e7e8'} stroke={'#d7282f'} />
        <G fill="none" stroke={'#2d2f38'}>
          {cameraPaths[model] ?? null}
        </G>
      </G>
    )
  },

  Chair: ({ arms = false, size = 0, x=0, y=0, a=0 }) =>
    <Fragment>
      <G fill='none' stroke='#000' strokeWidth='.75' strokeMiterlimit='10' shapeRendering='geometricprecision' 
      transform={`translate(${x}, ${y}) rotate(${a}) scale(${size ? size / 31.18 : 1} ${size ? size / 30.11 : 1}) translate(${size ? 0 : 0}, ${size ? -25.2: 0})` }>
        <Path d="m49.32863,84.5c37.36737,0 31.80172,-24.68478 31.80172,-24.68478l-3.51085,-24.57592c-1.5377,-14.00256 -13.81205,-13.97534 -13.81205,-13.97534l-25.36517,0
        c-15.60829,2.38139 -16.4792,16.16622 -16.4792,16.16622c-0.46267,3.97351 -3.44281,24.3854 -3.44281,24.3854c-1.49687,13.40381 7.98785,18.7109 7.98785,18.7109
        c6.99447,3.97351 22.82049,3.97351 22.82049,3.97351l0.00002,0.00001zm-22.34422,-96.79318c0,0 10.9816,-1.18389 24.71199,-1.18389c13.71679,0 21.55496,1.18389 21.55496,1.18389
        c10.4781,1.27915 7.47075,11.56674 7.47075,11.56674c-0.10886,1.10224 -1.75542,8.45052 -2.21809,9.79771c-1.21111,3.51085 -3.48363,5.89223 -6.58624,7.18499
        c-2.24531,0.93895 -4.58587,1.59213 -6.99447,1.59213c-0.47628,0 -0.93895,0 -1.41522,0l-26.79401,0c-0.46267,0 -0.93895,0 -1.41522,0c-2.4086,0 -4.74917,-0.65318 -6.99447,-1.59213
        c-3.10261,-1.30636 -5.37513,-3.67414 -6.58624,-7.18499c-0.46267,-1.34718 -2.10923,-8.69546 -2.21809,-9.79771c0,0 -3.00735,-10.28759 7.48436,-11.56674l-0.00001,0z"
          transform="scale(.3) rotate(90 50 50) translate(34, -34)" />
        <Path d="m20.23115,-5c0,0 8.09,-0.74 18.17,-0.59c10.08,0.16 15.82,1.12 15.82,1.12c3.63,0.5 5.03,2.43 5.49,4.34c0.32,-1.29 1.45,-7.4 -5.42,-8.35
        c0,0 -5.75,-0.96 -15.83,-1.11c-10.08,-0.16 -18.17,0.58 -18.17,0.58c-6.9,0.74 -5.96,6.88 -5.68,8.18c0.52,-1.89 1.98,-3.78 5.62,-4.17z 
        m13.1, 24.5 l5.97,0l0.04,-2.51l-5.97,0l-0.04,2.51z"  transform="scale(.415) rotate(89 50 50) translate(24, -28)" />
        {arms && <Path d="m52.12,47.92l-5.2,-19.8c-1.72,-6.11 -4.51,-5.75 -5.62,-5.55c-2.9,0.52 -2.48,3.24 -2.25,6.85l2.43,19.32c0.56,3.22 2.73,5.76 5.67,5.53c2.94,-0.22 5.17,-3.07 4.97,-6.35z
        m-71.95,-1.12l5.81,-19.62c1.91,-6.06 4.69,-5.61 5.79,-5.38c2.88,0.61 2.38,3.31 2.03,6.92l-3.02,19.24c-0.66,3.2 -2.91,5.67 -5.84,5.35c-2.93,-0.32 -5.07,-3.23 -4.77,-6.51z
        m14.28,-5.42l-2.63,-0.04l0.95,-6.06l2.6,0.12l-0.92,5.98zm43.56,1.18l2.63,0.04l-0.76,-6.08l-2.61,0.04l0.74,6z" transform="scale(.415) rotate(89 50 50) translate(44.6, -28)" />}
      </G>
    </Fragment>,
};



const deviceIcons = {
  'speakers': Icons.Speaker,
  'deviceArrow': Icons.DeviceArrow,
  'microphones': Icons.Microphone,
  'cameras': Icons.Camera,
};

const furnitureIcons = {
  'chair': Icons.Chair,
}
export default Icons;
export { deviceIcons, furnitureIcons };

// 'button_active': {
//   'border_stroke': 'var(--app-red)',
//   'border_fill': 'var(--app-light-gray)',
//   'icon_stroke': 'var(--app-dark-gray)',
//   'icon_fill': ' var(--app-dark-gray)',
//   border: '1px solid transparent'
// },

// :root {
//   --app-red: #d7282f;
//   --app-medium-gray: #74777a;
//   --app-light-gray: #e6e7e8;
//   --app-dark-gray: #2d2f38;
//   --app-custom-gray: #a5aaad;
// }